<template>
    <section class="table-section">
        <table class="table css-table widget-table table-fixed">
            <thead>
                <tr>
                    <th>Employee</th>
                    <th v-for="column in columns" :key="column.field" :class="{'text-right': column.align === 'right'}">{{ column.label }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in rows" :key="row.key">
                    <td>
                        <a v-if="row.employee_id" href @click.prevent="$emit('open-employee', row.employee_id)">{{ row.employee_name }}</a>
                        <span v-else>—</span>
                    </td>
                    <td v-for="column in columns" :key="column.field" :class="{'text-right': column.align === 'right'}">{{ cellValue(row, column) }}</td>
                </tr>
            </tbody>
        </table>
    </section>
</template>

<script>
// Generic renderer for a Changes report sub-table: an Employee link column (opens the
// EmployeeSidebar) followed by a flat list of rows against a column config
// ([{label, field, money, align}]). Null/blank attribution values render as an em dash.
export default {
    props: ['columns', 'rows'],
    emits: ['open-employee'],
    methods: {
        cellValue(row, column) {
            const value = row[column.field]
            if (value === null || value === undefined || value === '') {
                return '—'
            }
            if (column.date) {
                return this.$filters.date(value)
            }
            return column.money ? `$${value}` : value
        },
    },
}
</script>
